/*eslint-disable */
// import gpath_companyModel from '../../Model/gpath_company'
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let gpathCompanys = {
  /**
   * gpcpList
   */
  async gpcpList (context, whereFilter=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "gpath_company_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at gpcpList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * gpcpView
   */
  async gpcpView (context, gpcpId) {
    try {      
      let post_data = new FormData();
      post_data.append('gpcp_id', gpcpId);
      return await request.curl(context, "gpath_company_view", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at gpcpView() and Exception:",err.message)
    }    
  },

  /**
   * gpcpAdd
   */
  async gpcpAdd (context, gpcpObj) {
    try{
      let post_data = new FormData();
    
      for (let key in gpcpObj) {
        post_data.append(key, gpcpObj[key]);
      }

      return await request.curl(context, "gpath_company_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at gpcpAdd() and Exception:',err.message)
    }
  },

  /**
   * gpcpEdit
   */
  async gpcpEdit (context, gpcpObj) {
    try{
      let post_data = new FormData();
    
      for (let key in gpcpObj) {
        post_data.append(key, gpcpObj[key]);
      }

      return await request.curl(context, "gpath_company_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at gpcpEdit() and Exception:',err.message)
    }
  },

  /**
   * gpcpDelete
   */
  async gpcpDelete (context, gpcpId) {
    try{
      let post_data = new FormData();
      
      post_data.append('gpcp_id', gpcpId);

      return await request.curl(context, "gpath_company_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at gpcpDelete() and Exception:',err.message)
    }
  }
}

export {
  gpathCompanys
}
